/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Boost domain - Player boost abilities and power-ups
 * boost.config.ts - All boost-related configuration constants and parameters
 */

export const BOOST_MULTIPLIER = 12.0;
export const BOOST_SPEED_MULTIPLIER = 4.0;
export const BOOST_DURATION = 1.0;
export const BOOST_COOLDOWN = 8.0;

export const BULLET_MINIMUM_SPEED = 200;

export const BOOST_ACTIVATION_DELAY = 0.0;
export const BOOST_DECELERATION_RATE = 1.0;
